// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2lvFe","legacyBtn":"MutateMid_legacyBtn__1rLnv"};